export enum MonitoringEndOfServices {
    OK = 'OK',
    TOACTIONCC = 'To Action CC',
    URGENT = 'Urgent',
    TOFOLLOW = 'To Follow',
    ERROR = 'Error',
    FINISHED = 'Finished',
}
